export default __webpack_public_path__ + "static/media/besthuman.7e0b2419.png";